/**
 * Trusted Types helper for CSP compliance
 * Handles sites with require-trusted-types-for 'script' policy
 *
 * Uses a DEFAULT policy that intercepts ALL innerHTML assignments,
 * including Vue's v-html directive, and sanitizes them with DOMPurify.
 */

import dompurify from "dompurify";

let isDefaultPolicyCreated = false;

/**
 * Setup Trusted Types default policy with DOMPurify
 * This MUST be called before Vue app initialization
 *
 * The default policy intercepts ALL innerHTML/outerHTML assignments
 * and automatically sanitizes them with DOMPurify.
 */
export function setupDOMPurifyWithTrustedTypes(): void {
  // Only create policy once
  if (isDefaultPolicyCreated) {
    return;
  }

  // Check if Trusted Types API is available (Chromium-based browsers)
  if (typeof window !== "undefined" && (window as any).trustedTypes) {
    try {
      // Create DEFAULT policy - this intercepts ALL innerHTML assignments
      (window as any).trustedTypes.createPolicy("default", {
        createHTML: (input: string) => {
          // Use DOMPurify to sanitize and return TrustedHTML
          return dompurify.sanitize(input, { RETURN_TRUSTED_TYPE: true });
        },
      });

      isDefaultPolicyCreated = true;
      console.log("[Trusted Types] Default policy created");
    } catch (e) {
      // Policy might already exist (shouldn't happen with 'default')
      console.warn("[Trusted Types] Could not create default policy:", e);
    }
  }
}
